import { z } from "zod";
import {RaceFileTypeSchema} from "../../../domain/models/race";

export type RaceFileType = z.infer<typeof RaceFileTypeSchema>;

export const FILE_TYPE_LABELS: Record<z.infer<typeof RaceFileTypeSchema>, string> = {
    ANNOUNCEMENT: "Ausschreibung",
    STARTER: "Starterliste",
    RESULTS: "Ergebnisse"
};

export interface IFileStorage {
    saveRaceFile(
        raceId: string,
        fileType: RaceFileType,
        file: File | Buffer,
        originalFilename?: string,
        category?: string
    ): Promise<string>;

    deleteRaceFile(
        raceId: string,
        fileType: RaceFileType,
        fileId: string,
        category?: string
    ): Promise<void>;

    getRaceFile(
        raceId: string,
        fileType: RaceFileType,
        id?: string,
        category?: string
    ): Promise<{
        buffer: Buffer;
        filename: string;
        contentType: string;
    }>;

    getRaceFiles(
        raceId: string,
        fileType: RaceFileType
    ): Promise<Array<{
        buffer: Buffer;
        filename: string;
        contentType: string;
        category?: string;
    }>>;
}
